import { objectSpread2 as _objectSpread2, toArray as _toArray, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { REMOVE_ALL, REMOVE, ADD } from './actions.js';
import { AddMethod } from './constants.js';

var initialState = {
  events: []
};

var notifications = function notifications() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ADD:
      var newEvent = {
        id: action.id,
        title: action.title,
        type: action.eventType,
        message: action.message,
        customData: action.customData,
        primaryAction: action.primaryAction,
        expiry: action.expiry,
        creation: Date.now()
      };

      if (action.method === AddMethod.AddOrReplaceTop) {
        // check for duplicate event on top of the stack
        var _state$events = _toArray(state.events),
            lastEvent = _state$events[0],
            otherEvents = _state$events.slice(1);

        if (lastEvent && lastEvent.type === newEvent.type && lastEvent.message === newEvent.message) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            events: [_objectSpread2(_objectSpread2({}, lastEvent), {}, {
              expiry: newEvent.expiry,
              creation: newEvent.creation
            })].concat(_toConsumableArray(otherEvents))
          });
        }
      }

      return _objectSpread2(_objectSpread2({}, state), {}, {
        events: [newEvent].concat(_toConsumableArray(state.events))
      });

    case REMOVE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        events: state.events.filter(function (e) {
          return e.id !== action.id;
        })
      });

    case REMOVE_ALL:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        events: []
      });

    default:
      return state;
  }
};

export { notifications as default };
